/**
 * procurementReferenceApi — RTK Query slice cho /purchase/references/* (Procurement
 * References switchboard, Access `frmProcurementMainSubFormReferences`). Read-only:
 * mỗi pageKey trả 1 datasheet. Mirrors sale/purchase reference endpoints.
 */
import { baseApi } from './baseApi'

export type ProcurementReferenceRow = Record<string, unknown>

export interface ProcurementReferenceRowsQuery {
  pageKey: string
  limit?: number
  /** Shared "Inbound Logistics" filter — only ContractStatistics/PendingPayment use these. */
  startDate?: string | null
  endDate?: string | null
  isForcedClose?: boolean
}

export interface ProcurementReferencePageResponse {
  pageKey: string
  sourceForm: string
  sourceQuery: string
  items: ProcurementReferenceRow[]
  total: number
}

export const procurementReferenceApi = baseApi.injectEndpoints({
  endpoints: (b) => ({
    getProcurementReferenceRows: b.query<
      ProcurementReferencePageResponse,
      ProcurementReferenceRowsQuery
    >({
      query: ({ pageKey, limit = 1_000_000, startDate, endDate, isForcedClose }) => ({
        url: `/purchase/references/${encodeURIComponent(pageKey)}`,
        params: {
          limit,
          ...(startDate ? { start_date: startDate } : {}),
          ...(endDate ? { end_date: endDate } : {}),
          ...(isForcedClose !== undefined ? { is_forced_close: isForcedClose } : {}),
        },
      }),
      // Reload chung (ProcurementPage) refetch được từng reference page qua tag.
      providesTags: (res) =>
        res
          ? [
              { type: 'ProcReference' as const, id: res.pageKey },
              { type: 'ProcReference' as const, id: 'LIST' },
            ]
          : [{ type: 'ProcReference' as const, id: 'LIST' }],
    }),
  }),
})

export const { useGetProcurementReferenceRowsQuery } = procurementReferenceApi
